import { StringKeyDictionary } from "../../commonInterfaces.js";
import { DynamicSearchContextHook } from "../../dynamicSearch/hooks.js";
import { LinkedType } from "../../tasks/workPackage/workPackage.js";
import { Helper } from "../util/helper.js";

export let Config: InnoCofig = {
    baseUrl: null,
    pageTitle: null,
    user: {
        groupName: null,
        hasMobileLicense: false,
        hasDispatchLicense: false,
        groupNumber: null,
        languageId: null,
        languageCode: null,
        mainGroupName: null,
        mainGroupNumber: null,
        userName: null,
        userEmail: null,
        fullName: null,
        isExternal: false,
        isSysAdmin: false,
        systemRight: 0,
        RechtRechnungSchreiben: false,
        timezoneWindows: null,
        timezoneIANA: null,
        showDataExchangeModul: null,
        saveTimeShift: null,
        extendedLoginActivated: null,
        showMobileClientAppProfileOnly: null,
        qrEnabled: null,
        autoload: null,
        autoloadtime: null,
        openHotKeyInNewTab: null,
        activateLbarbeitValidation: null,
        abhaenigkeitCodes: null,
        queryAssignmentShift: false,
        showRebookReport: null,
        rueckreiseModus: null,
        rueckreiseModusZentral: null,
        isZentralerUser: null,
        splitUpAndCutAssignment: null,
        individualData: null,
        iconsAreActive: false,
        addressRights: false,
        machineRights: false,
        slaManagementRight: false,
        autoCalcTravelStart: false,
        checkMultipleOccupancy: 0,
        useTemplateInResourcePlanning: true,
        restrictSendState: false,
        skills: {},
        culture: null,
        canCreateAssignment: false,
        activeExtendedProjectFilter: false,
        projectRangeLimit: null
    },
    settings: {
        useStandardDashboard: false,
        allowDashboardNameChange: false,
        isFieldServiceDB: false,
        einfacheKapazitaetsberechnung: false,
        capacityCalculationMode: 0,
        flagsAreActive: false,
        approvalProcessActive: false,
        hideInvisbleAssignments: false,
        useRoles: false,
        smartSearchActive: false,
        auArtNuKreisActive: false,
        activateLbarbeitValidation: false,
        globalLinkedType: LinkedType.Assignments,
        resetSendStateAtDTSChange: false,
        sendStateAtDTSChange: null,
        updateSendStatusWhenChangingAssignment: 0,
        customerPortal: null,
        documentBasePathIsConfigured: null,
        useDocumentSubCategories: null,
        useDocumentFolderStructure: null,
        disableReloadOnReconnect: false,
        disableMessageBoxOnReconnect: false,
        useIndCategories: null,
        movingAssignmentInMobileClientAction: 0,
        deletingAssignmentInMobileClientAction: 0,
        excludedKnrsForForbiddenMobileClientAction: [],
        printJobPollingTimeInSeconds: 60,
        teamsIntegrationActive: false,
        optionEIdActive: false,
        skills: {
            useSkills: false,
            useMainGroupSkills: false,
            usePrioritySkills: false,
            useTargetValueSkills: false,
            maxSkillValue: null,
            maxPriorityValue: null
        },
        useDashboardForExternal: false,
        useMobileGui: false,
        isMobileApp: false,
        mobileAppCulture: null,
        serviceReport: {
            copyTimes: 0,
            copyCashExpenses: 0,
            copyMaterials: 0,
            copyDocuments: 0,
            copyDocumentsCashExpenses: 0
        },
        extendedProjectFilterLimit: null,
        bookmarks: {
            maxAmount: 8
        },
        openAI: {
            isActive: false,
            name: null
        }
    },
    translations: {
        get openPrintDialog(): string {
            return Helper.getTranslation("Standard.OpenPrintDialog");
        },
        get createReport(): string {
            return Helper.getTranslation("Reports.Create");
        },
        get addressSearch(): string {
            return Helper.getTranslation("Adresse.AdresseSuchen");
        },
        get backLabel(): string {
            return Helper.getTranslation("Standard.BackBtn");
        },
        get contactSearch(): string {
            return Helper.getTranslation("Ansprechpartner.Ansprechpartnersuche");
        },
        get copyLabel(): string {
            return Helper.getTranslation("Standard.Kopieren");
        },
        get deleteLabel(): string {
            return Helper.getTranslation("Standard.Loeschen");
        },
        get deleteMessage(): string {
            return Helper.getTranslation("Standard.Msg.Loeschen");
        },
        get editLabel(): string {
            return Helper.getTranslation("Standard.Editieren");
        },
        get savingErrorMessage(): string {
            return Helper.getTranslation("Standard.Msg.SpeichernFehler");
        },
        get machineSearch(): string {
            return Helper.getTranslation("Maschine.Maschinensuche");
        },
        get projectSearch(): string {
            return Helper.getTranslation("Projekt.Projektsuche");
        },
        get reloadLabel(): string {
            return Helper.getTranslation("MonitorBaum.NeuLaden");
        },
        get resourceSearch(): string {
            return Helper.getTranslation("Ressource.Suchen");
        },
        get saveLabel(): string {
            return Helper.getTranslation("Standard.Speichern");
        },
        get savingSuccessfulMessage(): string {
            return Helper.getTranslation("Standard.Msg.SpeichernErfolgreich");
        },
        get ticketSearch(): string {
            return Helper.getTranslation("Vorgang.Ticketsuche");
        },
        get newLabel(): string {
            return Helper.getTranslation("Standard.Neu");
        },
        get pleaseSelect(): string {
            return Helper.getTranslation("Standard.BitteWählen");
        },
        get noHelpFile(): string {
            return Helper.getTranslation("WebSMS.Messages.NoHelp");
        },
        get invalidDateFormat(): string {
            return Helper.getTranslation("Standard.UngültigesDatumsformat");
        },
        get mandatoryField(): string {
            return Helper.getTranslation("Standard.Pflichtfeld");
        },
        get maxValue(): string {
            return Helper.getTranslation("Standard.MaxValue");
        },
        get minValue(): string {
            return Helper.getTranslation("Standard.MinValue");
        },
        get atLeastOne(): string {
            return Helper.getTranslation("Standard.MindestensEin");
        },
        get dataNotSavedMessage(): string {
            return Helper.getTranslation("WebSMS.Messages.DataNotSavedYet");
        },
        get closeAndDiscardMessage(): string {
            return Helper.getTranslation("WebSMS.Messages.CloseWndAndDiscardChanges");
        },
        get email(): string {
            return Helper.getTranslation("WebCRM.Email.Email");
        },
        get emailHistory(): string {
            return Helper.getTranslation("WebCRM.Email.EmailHistory");
        },
        get noConnection(): string {
            return Helper.getTranslation("WebSMS.Common.NotConnected");
        },
        get filter(): string {
            return Helper.getTranslation("Standard.Filtern");
        },
        get from(): string {
            return Helper.getTranslation("Standard.Von");
        },
        get to(): string {
            return Helper.getTranslation("Standard.Bis");
        },
        get close(): string {
            return Helper.getTranslation("Standard.CloseBtn");
        },
        get select(): string {
            return Helper.getTranslation("Standard.Auswählen");
        },
        get saveDataFirst(): string {
            return Helper.getTranslation("WebSMS.Messages.SaveDataFirst");
        },
        get serviceUnavailable(): string {
            return Helper.getTranslation("WebSMS.Messages.ServiceUnnavailable");
        },
        get qrReportGenerationFailed(): string {
            return Helper.getTranslation("WebSMS.Messages.QRReportGenerationFailed");
        },
        get addPointToRoute(): string {
            return Helper.getTranslation("GeoMap.AddToGeomapRoute");
        },
        get pointAdded(): string {
            return Helper.getTranslation("GeoMap.PointAdded");
        },
        get addPointFailure(): string {
            return Helper.getTranslation("GeoMap.AddPointFailure");
        },
        get tabAndRouteSelection(): string {
            return Helper.getTranslation("GeoMap.TabAndRouteSelection");
        },
        get general(): string {
            return Helper.getTranslation("Server.Allgemein");
        },
        get search(): string {
            return Helper.getTranslation("Standard.Suchen");
        },
        get userSearch(): string {
            return Helper.getTranslation("Standard.Benutzersuche");
        },
        get loadLabel(): string {
            return Helper.getTranslation("Standard.Laden");
        },
        get apply(): string {
            return Helper.getTranslation("Standard.Übernehmen");
        },
        get ignore(): string {
            return Helper.getTranslation("Standard.Ignore");
        },
        get ok(): string {
            return Helper.getTranslation("Standard.OK");
        },
        get documentsUpdateExisting(): string {
            return Helper.getTranslation("WebSMS.Documents.UpdateExisting");
        },
        get documentsAddAsNew(): string {
            return Helper.getTranslation("WebSMS.Documents.AddAsNew");
        },
        get details(): string {
            return Helper.getTranslation("Standard.Details");
        },
        get cancel(): string {
            return Helper.getTranslation("Standard.Abbrechen");
        },
        get unsupportedImagefile(): string {
            return Helper.getTranslation("WebSMS.Resource.UngueltigeBilddatei");
        },
        get noImage(): string {
            return Helper.getTranslation("WebSMS.Resource.KeinBild");
        },
        get add(): string {
            return Helper.getTranslation("Standard.Add");
        },
        get delete(): string {
            return Helper.getTranslation("Standard.Loeschen");
        },
        get deleteUserWarn(): string {
            return Helper.getTranslation("Standard.LoeschenUserWarn");
        },
        get followed(): string {
            return Helper.getTranslation("WebSMS.Events.Followed");
        },
        get follow(): string {
            return Helper.getTranslation("WebSMS.Events.Follow");
        },
        get unfollow(): string {
            return Helper.getTranslation("WebSMS.Events.Unfollow");
        },
        get advanced(): string {
            return Helper.getTranslation("Standard.Erweitert");
        },
        get quick(): string {
            return Helper.getTranslation("Standard.Schnell");
        },
        get actions(): string {
            return Helper.getTranslation("Standard.Aktionen");
        },
        get sections(): string {
            return Helper.getTranslation("Standard.Bereiche");
        },
        get deactivate(): string {
            return Helper.getTranslation("Server.Settings.Deactivate");
        },
        get activate(): string {
            return Helper.getTranslation("Server.Settings.Activate");
        },
        get validEmail(): string {
            return Helper.getTranslation("Standard.ValidateEmail");
        },
        get reset(): string {
            return Helper.getTranslation("Standard.Clear");
        },
        get language(): string {
            return Helper.getTranslation("Field.Adresse.language");
        },
        datetime: {
            get ago(): string {
                return Helper.getTranslation("WebSMS.Common.DateTime.Vor");
            },
            get centuries(): string {
                return Helper.getTranslation("WebSMS.Common.DateTime.Jahrhunderte");
            },
            get days(): string {
                return Helper.getTranslation("WebSMS.Common.DateTime.Tage");
            },
            get fromnow(): string {
                return Helper.getTranslation("WebSMS.Common.DateTime.VonJetztAn");
            },
            get hours(): string {
                return Helper.getTranslation("WebSMS.Common.DateTime.Stunden");
            },
            get justnow(): string {
                return Helper.getTranslation("WebSMS.Common.DateTime.Gerade");
            },
            get lastcentury(): string {
                return Helper.getTranslation("WebSMS.Common.DateTime.LetztesJahrhundert");
            },
            get lastmonth(): string {
                return Helper.getTranslation("WebSMS.Common.DateTime.LetztenMonat");
            },
            get lastweek(): string {
                return Helper.getTranslation("WebSMS.Common.DateTime.LetzteWoche");
            },
            get lastyear(): string {
                return Helper.getTranslation("WebSMS.Common.DateTime.LetztesJahr");
            },
            get minute(): string {
                return Helper.getTranslation("WebSMS.Common.DateTime.Minute");
            },
            get minutes(): string {
                return Helper.getTranslation("WebSMS.Common.DateTime.Minute");
            },
            get months(): string {
                return Helper.getTranslation("WebSMS.Common.DateTime.Monate");
            },
            get nextcentury(): string {
                return Helper.getTranslation("WebSMS.Common.DateTime.NaechstesJahrhundert");
            },
            get nextmonth(): string {
                return Helper.getTranslation("WebSMS.Common.DateTime.NaechstenMonat");
            },
            get nextweek(): string {
                return Helper.getTranslation("WebSMS.Common.DateTime.NaechsteWoche");
            },
            get nextyear(): string {
                return Helper.getTranslation("WebSMS.Common.DateTime.NaechstesJahr");
            },
            get seconds(): string {
                return Helper.getTranslation("WebSMS.Common.DateTime.Sekunden");
            },
            get tomorrow(): string {
                return Helper.getTranslation("WebSMS.Common.DateTime.Morgen");
            },
            get xtimeunityago(): string {
                return Helper.getTranslation("WebSMS.Common.DateTime.VorXZeiteinheit");
            },
            get xtimeunityfromnow(): string {
                return Helper.getTranslation("WebSMS.Common.DateTime.VonJetztAnXZeiteinheit");
            },
            get years(): string {
                return Helper.getTranslation("WebSMS.Common.DateTime.Jahre");
            },
            get yesterday(): string {
                return Helper.getTranslation("WebSMS.Common.DateTime.Gestern");
            },
            get hour(): string {
                return Helper.getTranslation("WebSMS.Common.DateTime.Stunde");
            },
            get weeks(): string {
                return Helper.getTranslation("WebSMS.Common.DateTime.Wochen");
            },
            get weekend(): string {
                return Helper.getTranslation("WebSMS.GeneralSettings.PlanningBoard.Weekend");
            },
        },
        reminders: {
            get reminder(): string {
                return Helper.getTranslation("WebSMS.Reminder.Reminder");
            },
            get reminders(): string {
                return Helper.getTranslation("WebSMS.Reminder.Reminder");
            },
        },
        get clearLabel(): string {
            return Helper.getTranslation("Standard.Clear");
        },
        get discardChanges(): string {
            return Helper.getTranslation("WebSMS.Messages.DiscardChanges");
        },
        get closeSheet(): string {
            return Helper.getTranslation("Standard.CloseSheet");
        },
        get myTaskReminder(): string {
            return Helper.getTranslation("Standard.ReminderObject");
        },
        get imagePreview(): string {
            return Helper.getTranslation("Dokument.ImagePreview");
        },
        get clickToClose(): string {
            return Helper.getTranslation("Dokument.ClickToClose");
        },
        get clickToOpenFullscreen(): string {
            return Helper.getTranslation("Dokument.ClickToOpenFullscreen");
        },
        get savePerCrtlShift(): string {
            return Helper.getTranslation("Standard.SavePerCrtlShift");
        },
        get cancelEscape(): string {
            return Helper.getTranslation("Standard.CancelEscape");
        },
        get enterUrl(): string {
            return Helper.getTranslation("Dokument.EnterUrl");
        },
        get sessionReconnect(): string {
            return Helper.getTranslation("WebSMS.Login.Reconnect");
        },
        get valueFromParent(): string {
            return Helper.getTranslation("WebCRM.Tasks.TaskGroup.ValueFromParentUsed");
        },
        get valueFromParentOverridden(): string {
            return Helper.getTranslation("WebCRM.Tasks.TaskGroup.ValueFromParentOverridden");
        },
        get valueFromParentWithAction(): string {
            return Helper.getTranslation("WebCRM.Tasks.TaskGroup.ValueFromParentWithAction");
        },
        get remark(): string {
            return Helper.getTranslation("WebSMS.ResourcePlaningGrouping.GridBemerkung");
        },
        get userLogout(): string {
            return Helper.getTranslation("WebSMS.Common.UserLogout");
        },
        get namedUserLogout(): string {
            return Helper.getTranslation("WebSMS.Common.NamedUserLogout");
        },
        get openInNewTab(): string {
            return Helper.getTranslation("WebSMS.Common.OpenInNewTab");
        },
        get reEnterApiKey(): string {
            return Helper.getTranslation("WebSMS.Common.reEnterApiKey")
        },
        get deleteApiKey(): string {
            return Helper.getTranslation("WebSMS.Common.deleteApiKey")
        }
    },
    hooks: {
    },
    dynamicSearchContextHooks: {

    }
}
interface InnoCofig {
    baseUrl: string;
    pageTitle?: string;
    user: UserConfig;
    settings: Settings;
    translations: {
        openInNewTab: string;
        namedUserLogout: string;
        userLogout: string;
        openPrintDialog: string,
        createReport: string,
        newLabel: string,
        saveLabel: string,
        deleteLabel: string,
        reloadLabel: string,
        editLabel: string,
        copyLabel: string,
        backLabel: string,
        savingSuccessfulMessage: string,
        savingErrorMessage: string,
        deleteMessage: string,
        addressSearch: string,
        machineSearch: string,
        projectSearch: string,
        contactSearch: string,
        resourceSearch: string,
        ticketSearch: string,
        pleaseSelect: string,
        noHelpFile: string,
        invalidDateFormat: string,
        mandatoryField: string,
        validEmail: string,
        maxValue: string,
        minValue: string,
        atLeastOne: string,
        dataNotSavedMessage: string,
        closeAndDiscardMessage: string
        email: string;
        emailHistory: string;
        noConnection: string;
        filter: string;
        from: string;
        to: string;
        close: string;
        select: string;
        saveDataFirst: string;
        serviceUnavailable: string;
        qrReportGenerationFailed: string;
        addPointToRoute: string;
        pointAdded: string;
        addPointFailure: string;
        tabAndRouteSelection: string;
        general: string;
        search: string;
        userSearch: string;
        loadLabel: string;
        apply: string;
        ok: string,
        documentsUpdateExisting: string,
        documentsAddAsNew: string,
        details: string,
        cancel: string;
        unsupportedImagefile: string,
        noImage: string;
        add: string;
        delete: string;
        deleteUserWarn: string;
        followed: string;
        follow: string;
        unfollow: string;
        advanced: string;
        quick: string;
        ignore: string;
        sections: string;
        actions: string;
        deactivate: string;
        activate: string;
        reset: string;
        language: string;
        datetime: {
            seconds: string;
            minute: string;
            minutes: string;
            ago: string;
            fromnow: string;
            hours: string;
            yesterday: string;
            tomorrow: string;
            days: string;
            lastweek: string;
            nextweek: string;
            lastmonth: string;
            nextmonth: string;
            months: string;
            lastyear: string;
            nextyear: string;
            years: string;
            lastcentury: string;
            nextcentury: string;
            centuries: string;
            justnow: string;
            xtimeunityago: string;
            xtimeunityfromnow: string;
            hour: string;
            weeks: string;
            weekend: string;
        };
        reminders: {
            reminder: string;
            reminders: string;
        };
        clearLabel: string;
        discardChanges: string;
        closeSheet: string;
        myTaskReminder: string;
        imagePreview: string;
        clickToClose: string;
        clickToOpenFullscreen: string;
        savePerCrtlShift: string;
        cancelEscape: string;
        enterUrl: string;
        sessionReconnect: string;
        valueFromParent: string;
        valueFromParentOverridden: string;
        valueFromParentWithAction: string;
        remark: string;
        reEnterApiKey: string;
        deleteApiKey: string;
    };
    hooks: { [context: string]: Hooks };
    dynamicSearchContextHooks: StringKeyDictionary<{ hook: DynamicSearchContextHook; overwrite: boolean }>;
}

interface UserConfig {
    userName: string;
    groupName: string;
    groupNumber: number;
    mainGroupName: string;
    mainGroupNumber: number;
    culture: string;
    languageId: number;
    languageCode: string;
    userEmail: string;
    fullName: string;
    isExternal: boolean;
    isSysAdmin: boolean;
    systemRight: number;
    timezoneWindows: string;
    timezoneIANA: string;
    showDataExchangeModul: boolean;
    saveTimeShift: boolean;
    extendedLoginActivated: boolean;
    showMobileClientAppProfileOnly: boolean;
    qrEnabled: boolean;
    autoload: number;
    autoloadtime: number;
    openHotKeyInNewTab: boolean;
    RechtRechnungSchreiben: boolean;
    activateLbarbeitValidation: boolean;
    showRebookReport: boolean;
    abhaenigkeitCodes: boolean;
    queryAssignmentShift: boolean;
    rueckreiseModus: number;
    rueckreiseModusZentral: number;
    isZentralerUser: boolean;
    splitUpAndCutAssignment: boolean;
    individualData: {};
    iconsAreActive: boolean;
    addressRights: boolean;
    machineRights: boolean;
    ressNr?: string;
    slaManagementRight?: boolean;
    autoCalcTravelStart?: boolean;
    checkMultipleOccupancy: number;
    restrictSendState: boolean;
    hasMobileLicense: boolean;
    hasDispatchLicense: boolean;
    useTemplateInResourcePlanning: boolean;
    skills: {
        zuResource?: boolean;
        zuEinsatzUebertragen?: boolean;
        zuTicketUebertragen?: boolean;
        zuAdresse?: boolean;
        zuMaschine?: boolean;
        zuMaschinenTyp?: boolean;
        zuTicket?: boolean;
        zuProjekt?: boolean;
    }
    canCreateAssignment: boolean;
    activeExtendedProjectFilter?: boolean;
    projectRangeLimit?: number;
}


interface Settings {
    disableMessageBoxOnReconnect: boolean;
    disableReloadOnReconnect: boolean;
    isFieldServiceDB: boolean;
    einfacheKapazitaetsberechnung: boolean;
    capacityCalculationMode: number;
    flagsAreActive: boolean;
    approvalProcessActive: boolean;
    hideInvisbleAssignments: boolean;
    useRoles: boolean;
    customerPortal?: CustomerPortalSettings;
    smartSearchActive: boolean;
    auArtNuKreisActive: boolean;
    activateLbarbeitValidation: boolean;
    resetSendStateAtDTSChange: boolean;
    sendStateAtDTSChange: number;
    updateSendStatusWhenChangingAssignment: number;
    globalLinkedType: number;
    documentBasePathIsConfigured?: boolean;
    useDocumentSubCategories?: boolean;
    useDocumentFolderStructure?: boolean;
    useDocumentAddWithCanCancel?: boolean;
    useIndCategories?: boolean;
    movingAssignmentInMobileClientAction?: number;
    deletingAssignmentInMobileClientAction?: number;
    excludedKnrsForForbiddenMobileClientAction?: number[];
    printJobPollingTimeInSeconds: number;
    teamsIntegrationActive: boolean;
    optionEIdActive: boolean;
    skills: {
        useSkills: boolean;
        useMainGroupSkills: boolean;
        usePrioritySkills: boolean;
        useTargetValueSkills: boolean;
        maxSkillValue: number;
        maxPriorityValue: number;
    };
    useStandardDashboard: boolean;
    allowDashboardNameChange: boolean;
    useDashboardForExternal: boolean;
    useMobileGui: boolean;
    isMobileApp: boolean;
    mobileAppCulture: MobileAppCulture;
    serviceReport: {
        copyTimes: number,
        copyCashExpenses: number,
        copyMaterials: number,
        copyDocuments: number,
        copyDocumentsCashExpenses: number
    };
    extendedProjectFilterLimit?: number;
    bookmarks: {
        maxAmount: number;
    },
    openAI: {
        isActive: boolean;
        name: string;

    },
    warehouseActive?: boolean;
}
interface Hooks {
    //onBeforeWillMount?(): void;
    //onAfterWillMount?(): void;
    onBeforeDidMount?(): void;
    onAfterDidMount?(): void;
    onBeforeFieldChanged?(field: { model: string }, value: any, dataItem?: any, isInit?: boolean): void;
    onAfterFieldChanged?(field: { model: string }, value: any, dataItem?: any, isInit?: boolean): void;
    onBeforeValidate?(): boolean;
    onAfterValidate?(): boolean;
}
interface CustomerPortalSettings {
    serviceDocumentsActive?: boolean;
    machinesActive?: boolean;
    assignmentsActive?: boolean;
    maintenanceActive?: boolean;
    quoteActive?: boolean;
}

interface MobileAppCulture {
    languageCode: string;
    dateTimeFormat: {
        dateComponents: ("day" | "month" | "year")[];
        dateComponentSeparator: "." | "-" | "/";
        dateTimeSeparator: string;
        timeFormat: "twelvehour" | "twentyfourhour",
        shortDatePattern: string,
        shortTimePattern: string,
        longTimePattern: string
    };
    numberFormat: {
        numberDecimalSeparator: string;
        numberGroupSeparator: string;
    }
};